module.exports = __webpack_public_path__ + "img/电视机背板3.03dae71d.jpg";